<template>
  <div class="flexbox-s trenditem">
    <!-- 用户信息 -->
    <div class="flexbox userinfo">
      <!-- 头像 -->
      <div
        :to="'/m/home/my/newsfeed/' + data.mid"
        class="flexbox useravatar"
        @click="showDetail(data.id)"
      >
        <img class="avatar" :src="imgurl + data.avatar" />
      </div>
      <!-- 会员信息及用户名 -->
      <div class="flexbox-s namebox">
        <div class="username" @click="showDetail(data.id)">
          <i
            class="iconfont icon-V"
            style="color: gold"
            v-if="+data.vip == 2"
          ></i>
          <i
            class="iconfont icon-V"
            style="color: silver"
            v-else-if="+data.vip == 1"
          ></i>
          {{ data.username }}
        </div>
        <!-- 性别和年龄 -->
        <div class="flexbox sexandage">
          <i
            class="iconfont icon-nan"
            v-if="data.sex == 1"
            style="color: #99f"
          ></i>
          <i
            class="iconfont icon-nv"
            v-if="data.sex == 0"
            style="color: #f4a"
          ></i>
          <div class="age">
            {{
              new Date().getFullYear() -
                new Date(parseInt(data.birthday)).getFullYear()
            }}
          </div>
        </div>
      </div>
      <!-- 聊天icon -->
      <div class="chatbox">
        <i
          @click="addUserToChatList"
          class="iconfont icon-liaotian"
          style="color: #999; font-size: 30px"
        ></i>
      </div>
    </div>
    <!-- 动态内容 -->
    <div class="flexbox trendcontent">
      <div class="flexbox-s textsector">
        <!-- 用户发布得动态 -->
        <div v-if="data.type == 1">
          <ExpText :text="data.content" />
        </div>
        <!-- 加入了网站 -->
        <div v-if="data.type == 0">
          {{ $t("trend.joined") }}
        </div>
        <!-- 更换了头像 -->
        <div v-if="data.type == 2">
          {{ $t(`trend.avatar${data.sex}`) }}
        </div>
      </div>
      <div
        class="flexbox-s imagesector"
        v-if="data.img && data.img != 'null' && data.img != 'undefined'"
      >
        <div class="img">
          <el-image :src="url" lazy :preview-src-list="[url]"></el-image>
        </div>
      </div>
    </div>
    <!-- 发布时间 -->
    <div class="flexbox trendtime">
      <!-- {{ util.getTrendtimeByDate(new Date(data.create_time)) }} -->
    </div>
  </div>
</template>

<script>
import ExpText from "../Expression.vue";
export default {
  props: ["data"],
  computed: {
    date() {
      return $i18n.locale;
    },
    url() {
      return this.imgurl + this.data.img;
    },
    vip() {
      return this.$store.state.User.vip;
    },
  },
  components: {
    ExpText,
  },
  methods: {
    addUserToChatList() {
      if (!this.vip || ![1, 2].includes(+this.vip)) {
        this.$message.error(this.$t("tips.upmember1"));
        return;
      }
      this.$store.commit("addUserToChatList", this.data.user);
      this.$store.commit("setCur", this.data.mid);
      this.$router.push("/m/home/chat/index");
    },
    showDetail(id) {
      if (!this.vip || ![1, 2].includes(+this.vip)) {
        this.$message.error(this.$t("tips.upmember1"));
        return;
      }
      this.$router.push("/m/home/my/newsfeed/" + id);
    },
  },
};
</script>

<style lang="scss" scoped>
.trenditem {
  padding: 10px;
  border-bottom: 1px solid #eee;
  .userinfo {
    height: 70px;
    flex-wrap: nowrap;
    .useravatar {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      overflow: hidden;
      flex-shrink: 0;
      cursor: pointer;
      .avatar {
        width: 50px;
        height: 50px;
        border-radius: 50%;
      }
    }
    .namebox {
      padding-left: 10px;
      .username {
        width: 100%;
        color: #333;
        padding: 0 5px;
        font-weight: bold;
        cursor: pointer;
        margin-bottom: 5px;
      }
      .username:hover {
        text-decoration: underline;
      }
      .sexandage {
        width: auto;
        font-size: 14px;
        background-color: #f1f2f3;
        padding: 2px 8px;
        height: 20px;
        border-radius: 10px;
        .age {
          padding-left: 5px;
        }
      }
    }
  }

  .trendcontent {
    padding: 0 5px;
    color: #333;
    .textsector {
      margin-bottom: 10px;
    }
    .imagesector {
      padding: 0 10px;
      margin-bottom: 10px;
      .img {
        max-width: 200px;
        height: auto;
      }
    }
  }
  .trendtime {
    color: #aaa;
    width: auto;
    height: 30px;
    align-items: flex-end;
    align-content: flex-end;
    flex-shrink: 0;
    font-size: 12px;
  }
}
</style>
